module.exports = __webpack_public_path__ + "static/img/chengduwei1.2e7cd81.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/chengduwei1.png
// module id = 7OYd
// module chunks = 1